import React from 'react';
import PropertyAlgolia from "./PropertyAlgolia";
import DescCut from "./DescCut";
import { isNotEmpty } from "../../util/user";
import algoliasearch from "algoliasearch";
import {Link} from 'react-router-dom';
import loading from '../../images/loading.png';
// import header from '../../images/header.jpg';
import header_two_ham from '../../images/header_two_ham.jpg';
import header from '../../images/header.jpg';
import VidBox from '../VidBox'
import CustomPage from "./CustomPage"
import Helmet from "react-helmet";

function compare(a, b) {
  if (parseInt(a.objectID) < parseInt(b.objectID)) {
    return 1;
  }
  if (parseInt(a.objectID) > parseInt(b.objectID)) {
    return -1;
  }
  // a must be equal to b
  return 0;
}


export default class CustomPages extends React.Component {
  constructor(props) {
    var client = algoliasearch('PTGN8U7BAB', '1bd38ecdf030101a4cff6d2447e8de2e');

    super(props);
    this.state = {
      results: [],
      imageCompanies: [],
      loading: true,
      searchingFor: "",
      currentPage: 0,
      pageTotal: 10,
      pageSize: 9,
      header: 1,
      client: client,
      textToShow: "job",
      posts: [],
      subcategoryParam: null
    };

    this.Listings = React.createRef();
    this.searchListings = this.searchListings.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.goToSearch = this.goToSearch.bind(this);
    this._handleKeyDown = this._handleKeyDown.bind(this);
  }

  handleChange(e) {
    this.setState({ searchingFor: e.target.value });
  }

  _handleKeyDown(e) {
    if (e.key === 'Enter') {
      this.goToSearch()
    }
  }

  goToSearch() {
    const url = `/browse?search=${encodeURIComponent(this.state.searchingFor)}`;
    this.props.history.push(url);
  }

  parseQueryParams() {
    const urlParams = new URLSearchParams(window.location.search);
    const subcategoryParam = urlParams.get('subcategory');

    if (true) {
      this.setState({
        subcategoryParam: subcategoryParam
      }, () => {
        this.searchListings();
      });
    }
  }

  searchListings(e) {
    const state = this;

    const token = localStorage.getItem("auth_token");
    var myHeaders = new Headers({
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    });

    var myInit = {
      method: 'GET',
      headers: myHeaders
    };

    let url = `${process.env.REACT_APP_API_HOST}/api/custom_pages`

    if (isNotEmpty(this.state.subcategoryParam)) {
      url = `${process.env.REACT_APP_API_HOST}/api/custom_pages?subcategory=${this.state.subcategoryParam}`
    }

    var myRequest = new Request(`${url}`, myInit);

    fetch(myRequest)
    .then((json) => json.json())
    .then((content) => {
      state.setState({
        posts: content.custom_pages,
        mounted: true,
        loading: false
      });

      return content;
    });

  }

  componentDidMount() {
    // this.searchListings();
    this.parseQueryParams();
  }

  render() {
    let show;
    let posts = this.state.posts;

    if (this.state.loading) {
      show = <div id="loading-state"><img src={loading} /></div>
    } else {
      show = <div></div>
    }


    return (
      <div className="ctn-jobs">
        <Helmet>
          <title>Hamilton Homes - Blog</title>
          <meta name="description" content="Explore the beautiful GTHA communities and all we can offer you with our local expertise of the area!"/>
          <meta name="keywords" content="buying,communities,ancaster,stoney creek,niagara,waterdown, grimsby, burlington, Flamborough, dundas, brantford, amilton,homes,for,sale,niburski,search,condos,luxury,business"/>

          <meta property="og:url" content="https://besthamiltonhouses.com/communities"/>
          <meta property="og:title" content="Hamilton Homes - Posts"/>
          <meta property="og:description" content="Explore the beautiful GTHA communities and all we can offer you with our local expertise of the area!"/>
        </Helmet>

        <VidBox />

        <div className="all-jobs">
          {show}
        </div>

        <div className="posts">
          <h2 className="heading">Blog Posts</h2>
          <div className="row all-jobs-row">

            <div ref={this.Listings} className="container" id="jobs-container">
              {posts.map(function(listing, index) {
                return (
                  <span key={"community-result" + index} className="job-ctn">
                    <div className="job-outline property-outline">
                      <CustomPage customPage={listing} />
                    </div>
                  </span>
                )
              })}
            </div>
          </div>
        </div>

        <div className="more-info">
          <img src={header_two_ham}/>
          <h2>We are a husband wife team with over 35 years of experience in real estate.</h2>
        </div>
      </div>
    )
  }
};
